{
  "alert": "アラート",
  "dismiss": "閉じる"
}
